import GpParser from '../../gpParser';
import { CATEGORIES } from '../../configuration/constants';

import Form from './Form';
// import Label from './Label';
import FormGroup from './FormGroup';
import FormInput from './FormInput';
// import FormSwitch from './FormSwitch';
import FormSelect from './FormSelect';
import MdcTextField from './MdcTextField';
import MdcSelect from './MdcSelect';
import dateRangePicker from './FormDateRangePicker';
import Multiline from './Multiline'
import CheckboxGroup from './CheckboxGroup'
import RankingList from './RankingList'

export default (editor, opt = {}) => {
  GpParser.loadFromList([
    Form,
    FormGroup,
    FormInput,
    dateRangePicker,
    // FormSwitch,
    FormSelect,
    MdcTextField,
    MdcSelect,
    Multiline,
    CheckboxGroup,
    RankingList
  ], CATEGORIES.FORM, editor, opt);
}
